/* -----------------UI--------------- */
import { Stack, useLocalSearchParams } from "expo-router";

/* -----------------Helpers & Hooks--------------- */
import { useAppStore } from "@hooks/useAppStore";
import { useRouter } from "expo-router";

/* -----------------Child components--------------- */
import { EmailContainer } from "@memorang/applets";

import { OnboardingAppBar } from "@features/auth";
import { buildType, currentAppVersion } from "@helpers/expo-extras";
import { captureErrorToSentry } from "@helpers/sentry-logger";
import { useDevice } from "@hooks/useDevice";
import { useGlobalStore } from "@hooks/useGlobalStore";
import { baseDevUrl, isDev } from "@memorang/constants";
import { useToast } from "@memorang/ui";
/* -----------------Analytics--------------- */
import { trackCustomEvent } from "analytics";
import DocumentTitle from "components/DocumentTitle";

const LoginPage = () => {
	const router = useRouter();

	const { companyName, supportEmail, baseUrl, app, tenant, tos, privacy } =
		useAppStore((store) => ({
			app: store.app,
			tenant: store.tenant,
			companyName: store.companyName,
			supportEmail: store.supportEmail,
			baseUrl: store.app.links.baseUrl,
			tos: store.app.links.tos,
			privacy: store.app.links.privacy,
		}));
	const { isMobile } = useDevice();
	const { showToast } = useToast();

	const appId = app.id;
	const tenantId = tenant.id;

	const baseRedirectUrl = isDev ? baseDevUrl : baseUrl;

	const lastLoggedInEmail = useGlobalStore((state) => state.lastLoggedInEmail);
	const params = useLocalSearchParams<{
		redeemCode: string;
		email: string;
	}>();
	// useEffect(() => {
	// 	trackPageView({ type: pageViewTypes.login });
	// }, []);

	const title = "Continue with email";

	const emailFromUrl = params?.email
		? decodeURIComponent(params?.email).replace(/ /g, "+")
		: "";

	const handleNewUserSignUp = () => {
		//TODO: implement before merging to main
	};

	const onError = (message: string) => {
		showToast({ message });
	};

	const logError = (error: unknown, title: string) => {
		captureErrorToSentry(new Error(title), {
			error: JSON.stringify(error),
		});
	};

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: true,
					header: () => {
						return (
							<OnboardingAppBar
								showLogo={!isMobile}
								title={title}
								onBackAction={() => router.back()}
							/>
						);
					},
				}}
			/>
			<DocumentTitle title="Login" />
			<EmailContainer
				handleTracking={trackCustomEvent}
				handleNewUserSignUp={handleNewUserSignUp}
				companyName={companyName}
				lastLoggedInEmail={lastLoggedInEmail}
				supportEmail={supportEmail}
				buildType={buildType}
				appId={appId}
				tenantId={tenantId}
				redirectUrl={`${baseRedirectUrl}/verify`}
				currentAppVersion={currentAppVersion!}
				emailFromUrl={emailFromUrl}
				tos={tos}
				privacy={privacy}
				logError={logError}
				onError={onError}
			/>
		</>
	);
};

export default LoginPage;
